let discountsDiv = document.querySelector('.quantity-discount');

document.addEventListener('DOMContentLoaded', () => {
    let variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
        let variantId = variantInput.value;
        const responseJson = calcVolumeDiscountMethod(variantId);
        drawDiscounts(responseJson);
    }
});
    const calcVolumeDiscountMethod = (variantId) => {
        let variantsData = JSON.parse(document.querySelector('#quantity-discount').textContent.trim());
    
        if (!variantsData[variantId]) {
            console.warn(`No se encontraron descuentos para la variante ${variantId}`);
            return null;
        }
    
        let variantData = variantsData[variantId];

        if(!variantData.discounts || variantData.discounts === null) {
            console.warn(`No se encontraron descuentos para la variante ${variantId}`);
            return null;
        }
    
        let sortedDiscounts = variantData.discounts.sort((a, b) => a.quantity - b.quantity);
    
        let responseJson = sortedDiscounts.map(discount => {
            let discountedPrice = variantData.price * (1 - discount.discount / 100);
            return {
                quantity: discount.quantity,
                price: discountedPrice.toFixed(2),
                diff: (variantData.price - discountedPrice).toFixed(2)
            };
        });
    
        console.log(`Descuentos para la variante ${variantId}:`, responseJson);
        return responseJson;
    };

document.addEventListener('product:variant-change', (event) => {
    const responseJson = calcVolumeDiscountMethod(event.detail.variant.id);
    drawDiscounts(responseJson);
});


let drawDiscounts = (discounts) => {
    discountsDiv.querySelector('.quantity-discount-table__body').innerHTML = '';
    if(!discounts || discounts === null){
        discountsDiv.style.display = 'none';
        return;
    }

    discounts.length > 0 ? discountsDiv.style.display = 'block' : discountsDiv.style.display = 'none';
    for (let discount of discounts) {
        let discountDiv = document.createElement('div');
        discountDiv.classList.add('discount');
        let maxDiscount = parseFloat(discount.diff*discount.quantity).toFixed(2);
        let diffPrice = parseFloat(discount.currentPrice - discount.price).toFixed(2);
        discountDiv.innerHTML = `
            <div>${discount.quantity}</div>
            <div>${discount.price.toString().replace(".",",")}€</div>
            <div>Hasta ${maxDiscount.toString().replace(".",",")}€</div>
        `;
        discountsDiv.querySelector('.quantity-discount-table__body').appendChild(discountDiv);
    }
};  